import TextField from '@material-ui/core/TextField'
import React from 'react'
import { controlHasError } from '../../lib/errorHandler'
import ExpandablePanel from '../controls/ExpandablePanel'
import PrintText from '../../lib/PrintText'

class Uproszczenia extends React.Component {
  render() {
    let placeholder
    switch (this.props.KodSprawozdania) {
      case 'SprFinJednostkaMalaWZlotych':
      case 'SprFinJednostkaMalaWTysiacach':
        placeholder =
          'Zastosowane uproszczenia przewidziane dla jednostek małych'
        break
      case 'SprFinJednostkaMikroWZlotych':
      case 'SprFinJednostkaMikroWTysiacach':
        placeholder =
          'Zastosowane zasady rachunkowości przewidziane dla jednostek mikro z wyszczególnieniem wybranych uproszczeń'
        break
      default:
        placeholder = ''
    }
    return (
      <ExpandablePanel title="UPROSZCZENIA">
        <form autoComplete="off" className="uproszczenia">
          {this.props.czyPodsumowanie ? (
            <PrintText
              text={this.props.data.Uproszczenia}
            />
          ) : (
            <TextField
              error={controlHasError(this.props.errors, 'Uproszczenia')}
              name="Uproszczenia"
              label={placeholder}
              placeholder={placeholder}
              multiline
              variant="outlined"
              title={this.props.data.Uproszczenia}
              defaultValue={this.props.data.Uproszczenia}
              onBlur={(e) =>
                this.props.onSetSectionData('Uproszczenia', e.target.value)
              }
            />
          )}
        </form>
      </ExpandablePanel>
    )
  }
}

export default Uproszczenia
